import * as React from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Box, Button, useMediaQuery } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const rows = [
	{ id: 1, code: 'Hello', name: 'World' },
	{ id: 2, code: 'DataGridPro', name: 'is Awesome' },
];

const columns = [
	{ field: 'code', headerName: 'Code' },
	{ field: 'name', headerName: 'Name' },
	{ field: 'type', headerName: 'Type' },
	{ field: 'totalInStock', headerName: 'Total In-Stock', type: 'number' },
	{ field: 'averageCost', headerName: 'Average Cost', type: 'number' },
	{
		field: 'reorderPoint',
		headerName: 'Reorder Point',
		type: 'number',
		initVisible: false,
	},
	{
		field: 'orderUpToLevel',
		headerName: 'Order Up to Level',
		type: 'number',
	},
	{
		field: 'unitsPerCase',
		headerName: 'Units Per Case',
		type: 'number',
		initVisible: false,
	},
	{
		field: 'lastCost',
		headerName: 'Last Cost',
		type: 'number',
		initVisible: false,
	},
	{ field: 'inWarehouse', headerName: 'In Warehouse', type: 'number' },
	{
		field: 'inMachines',
		headerName: 'In Machines',
		type: 'number',
		initVisible: false,
	},
	{
		field: 'status',
		headerName: 'Status',
		type: 'boolean',
		initVisible: false,
	},
	{ field: 'barcode', headerName: 'Barcode', type: 'number' },
];

function Toolbar() {
	const smBreakpoint = useMediaQuery((theme) => theme.breakpoints.down('lg'));
	return (
		<Box
			sx={{
				display: 'flex',
				padding: '0.5rem',
				gap: smBreakpoint ? 2 : 0,
				justifyContent: 'space-between',
				flexDirection: smBreakpoint ? 'column' : 'row',
			}}
		>
			<Box>
				<Button
					to='/products/create'
					component={Link}
					startIcon={<Add />}
					variant='outlined'
					size={'small'}
				>
					Create product
				</Button>
			</Box>
			<GridToolbar />
		</Box>
	);
}

export default function Products(params) {
	let initHidden = columns.filter((col) => col.initVisible === false);
	if (initHidden.length) {
		const temp = initHidden;
		initHidden = {};
		for (let col of temp) initHidden[col.field] = false;
	}

	return (
		<DataGrid
			rows={rows}
			columns={columns}
			initialState={{
				columns: {
					columnVisibilityModel: initHidden,
				},
			}}
			slots={{ toolbar: Toolbar }}
			slotProps={{
				toolbar: {
					showQuickFilter: true,
				},
			}}
			autosizeOnMount={true}
			autosizeOptions={{
				includeHeaders: true,
				includeOutliers: true,
				expand: true,
			}}
		/>
	);
}
